import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'kt-dynamic-dialog',
  templateUrl: './dynamic-dialog.component.html',
  styleUrls: ['./dynamic-dialog.component.scss']
})
export class DynamicDialogComponent implements OnInit {

  viewLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DynamicDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  /**
	 * Close dialog with false result
	 */
	onCancelClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onOkClick(): void {
		/* Server loading imitation. Remove this */
		if (this.data.hideLoading) {
			this.dialogRef.close(true);
		} else {
			this.viewLoading = true;
			setTimeout(() => {
				this.dialogRef.close(true); // Keep only this row
			}, 2500);
		}
	}

}
